import type { FC, ReactNode } from 'react';

interface GridInputWrapperProps {
  isColumnFilter?: boolean;
  children: ReactNode;
}

const GridInputWrapper: FC<GridInputWrapperProps> = ({
  isColumnFilter = false,
  children,
}) => (
  <div
    className={
      isColumnFilter ? 'column-filter-input-container' : 'grid-input-container'
    }
  >
    {children}
  </div>
);

export default GridInputWrapper;
